/*
 * Helper to detect viewport sizes in JavaScript
 * Examples:
 *   viewport.is('xs')
 *   viewport.isEqualOrGreaterThan('md')
 */

const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

const viewport = {
	viewPortSize: function() {
		return window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');
	},

	is: function(size) {
		if ( sizes.indexOf(size) == -1 ) throw "no valid viewport name given";
		return this.viewPortSize() == size;
	},

	isEqualOrGreaterThan: function(size) {
		if ( sizes.indexOf(size) == -1 ) throw "no valid viewport name given";
		return sizes.indexOf(this.viewPortSize()) >= sizes.indexOf(size);
	},

	isEqualOrSmallerThan: function(size) {
		if ( sizes.indexOf(size) == -1 ) throw "no valid viewport name given";
		return sizes.indexOf(this.viewPortSize()) <= sizes.indexOf(size);
	}
}

export {viewport};
